import { render, staticRenderFns } from "./STableProductsComp.vue?vue&type=template&id=75251993&"
import script from "./STableProductsComp.vue?vue&type=script&lang=js&"
export * from "./STableProductsComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports